import React from "react";
import { Link } from "react-router-dom";
import { Box, Typography, Button, Container } from "@mui/material";
import { styled } from "@mui/system";
import NotAuthorizedgif from "../../Components/Assets/images/401.gif"; // Adjust the import path if needed

// Styled components using MUI's `styled` API
const GifImage = styled("img")({
  maxWidth: "100%", // Ensure responsiveness
  height: "auto",
  marginBottom: "16px",
});

const NotAuthorized = () => {
  return (
    <Container 
      maxWidth="sm" 
      sx={{ 
        textAlign: "center", 
        marginTop: 8, 
        padding: 4, 
        boxShadow: 3, 
        borderRadius: 2, 
        backgroundColor: "#ffffff" 
      }}
    >
      {/* Display the GIF */}
      <GifImage src={NotAuthorizedgif} alt="Not Authorized" />

      {/* Heading */}
      <Typography 
        variant="h4" 
        sx={{ fontWeight: "bold", color: "#333", marginBottom: 2 }}
      >
        403 - Not Authorized
      </Typography>

      {/* Description */}
      <Typography 
        variant="body1" 
        sx={{ color: "#555", marginBottom: 4 }}
      >
        You do not have permission to access this page.
      </Typography>

      {/* Button to navigate back */}
      <Button
        variant="contained"
        color="primary"
        component={Link}
        to="/"
        sx={{
          padding: "10px 20px",
          textTransform: "none",
          fontSize: "16px",
        }}
      >
        Go to Home
      </Button>
    </Container>
  );
};

export default NotAuthorized;
